import type { IHeaderMobile } from './data';

import {
  Box,
  HamburgerMenu,
  HeaderProfile,
  HeaderSearch,
  HStack,
  Icon,
  IconButton,
  Link,
  MobileCart,
} from '@/components';
import LogoLia from '@/svgs/liateam-logo.svg';

const HeaderMobile: IHeaderMobile = () => {
  return (
    <Box
      display={{ base: 'block', md: 'none' }}
      px={4}
      bg="white"
      mb="10px"
      pb="10px"
    >
      <HStack justifyContent="space-between" pt={4}>
        <HamburgerMenu />
        <IconButton
          _hover={{ bgColor: 'transparent' }}
          aria-label="Logo Lia"
          bgColor="transparent"
          h="38px"
          w="114px"
          icon={
            <Link href="/" aria-label="logo">
              <Box style={{ paddingRight: 0, border: 0 }}>
                <Icon w="114px" h="38px" as={LogoLia} />
              </Box>
            </Link>
          }
        />
      </HStack>
      <HStack alignItems={'center'} justify="space-between" mt={'18px'}>
        <HeaderSearch />
        <Box display={'flex'} alignItems={'center'} gap={5}>
          <MobileCart />
          <HeaderProfile />
        </Box>
      </HStack>
    </Box>
  );
};
export default HeaderMobile;
